import {writable} from 'svelte/store';
import helper from './helper'
import config from './config'

export const step = writable(1);
export const load = writable(false);
export const trackArray = writable([]);
export const tabImagesArray = writable([]);
export const track = writable({});
export const combinedArray = writable({});
export const categories = writable([]);
export const trackName = writable('');
export const minimalWidthItem = writable(500);
export const minimalWidthItemTop = writable(500);
export const responsiveClass = writable(false);
export const goodsList = writable([]);
export const hiddenGoodsList = writable([]);
export const selectedPlusItem = writable(null);
export const selectedItem = writable(null);
export const mainTabIndex = writable(0);
export const isDrag = writable(false);
export const draggedItem = writable(null);
export const onClickOutsideCheck = writable(false);
export const showModal = writable(false);
export const modalTitle = writable("");
export const modalType = writable(null);
export const modalState = writable(null);
export const modalOpened = writable(true);
export const helpIconRect = writable(null);
export const first = writable(false);
export const tabName = writable(null);
export const itemsObj = writable({});
export const observedRect = writable({});
export const preloader = writable(true);
export const order = writable({
    id: null,
    bitrix_id: null,
    userEmail: null,
    userPhone: null,
    userName: null,
    userComment: null,
    count: null,
});

let modalTimer

export const mutations = {
    setPreloader(value) {
        preloader.set(value)
    },
    setObservedRect(value) {
        observedRect.set(value)
    },
    setTabName(value) {
        tabName.set(value)
    },
    setOrder(value) {
        order.set(value)
    },
    setHelpIconRect(value) {
        console.log("setHelpIconRect value: ", value)
        helpIconRect.set(value)
    },
    setStep(value) {
        step.set(value)
    },
    setFirst(value) {
        first.set(value)
    },
    setShowModal(value) {
        showModal.set(value)
        if (!value) {
            modalOpened.set(false)
            modalTimer = setTimeout(() => {
                modalTitle.set("")
                modalType.set(null)
                modalState.set(null)
            },400)
        } else {
            clearTimeout(modalTimer)
            modalOpened.set(true)
        }
    },
    setModalTitle(value) {
        modalTitle.set(value)
    },
    setModalType(value) {
        modalType.set(value)
    },
    setModalState(value) {
        modalState.set(value)
    },
    setOnClickOutsideCheck(value) {
        onClickOutsideCheck.set(value)
    },
    loadComplete() {
        mutations.setPreloader(false)
        load.set(true)
    },
    setTrackArray(value) {
        for (let track of value) {
            track.detail_image = getImageUrl(track.detail_image)
            track.prev_image = getImageUrl(track.prev_image)
            track.schema_image = getImageUrl(track.schema_image)
            if (track.color_list) {
                for (let i in track.color_list) {
                    track.color_list[i] = getImageUrl(track.color_list[i])
                }
            }
        }
        trackArray.set(value);
    },
    setColorTrack(colorCode, image) {
        track.update((value) => {
            return {...value, colorCode, full_image: image}
        })
    },
    setTrack(value) {
        track.set(value);
        trackName.set(value.name)

    },
    setCombinedArray(value) {
        let items = {}
        let arrItems = {
            top: [],
            bottom: [],
            outer: [],
            additional: [],
        }
        for (let item of value) {
            if (item.position_additional) {
                arrItems.additional.push(item)
            }
            if (item.position_inner_bot) {
                arrItems.bottom.push(item)
            }
            if (item.position_inner_top) {
                arrItems.top.push(item)
            }
            if (item.position_outer) {
                arrItems.outer.push(item)
            }
            item._width = item.width
            Object.defineProperty(item, "width", {
                get: function() {
                    if (this._width == "100%") {
                        return "100%"
                    }
                    return +this._width
                },
                set: function (value) {
                    this._width = value
                }
            });

            item.icon_image = getImageUrl(item.icon_image)
            item.prev_image = getImageUrl(item.prev_image)
            item.layer_image = getImageUrl(item.layer_image)

            item.exception_place_bottom_bottom = getExceptionPlaceList(item.exception_place_bottom_bottom)
            item.exception_place_bottom_top = getExceptionPlaceList(item.exception_place_bottom_top)
            item.exception_place_top_bottom = getExceptionPlaceList(item.exception_place_top_bottom)
            item.exception_place_top_top = getExceptionPlaceList(item.exception_place_top_top)
            item.exception_place_left_top = getExceptionPlaceList(item.exception_place_left_top)
            item.exception_place_left_bottom = getExceptionPlaceList(item.exception_place_left_bottom)
            item.exception_place_right_top = getExceptionPlaceList(item.exception_place_right_top)
            item.exception_place_right_bottom = getExceptionPlaceList(item.exception_place_right_bottom)
            items[item.id] = item
        }
        combinedArray.set(arrItems)
        itemsObj.set(items)
    },
    setCategories(value) {
        let arrCategory = {}
        let objCategories = {}
        for (let category of value) {
            objCategories[category.id] = category
            category.image = getImageUrl(category.image)
        }
        for (let position in combined) {
            for (let item of combined[position]) {
                if (!arrCategory[position]) {
                    arrCategory[position] = {}
                }
                arrCategory[position][item.category_id] = objCategories[item.category_id]
                item.category = objCategories[item.category_id]
            }
            arrCategory[position] = Object.values(arrCategory[position])
        }
        categories.set(arrCategory)
    },
    setResponsiveClass(value) {
        responsiveClass.set(value)
    },
    addItem(inputItem, position = null, x = null) {
        let item = {...inputItem}
        Object.defineProperty(item, "width", {
            get: function() {
                if (this._width == "100%") {
                    if (this.position) {
                        return +currentTrack["width_" + this.position]
                    }
                    return "100%"
                }
                return +this._width
            },
            set: function (value) {
                this._width = value
            }
        });
        i++;
        if (i > 300) {
            throw {message: "end"};
            return
        }
        item.tabName = currentTabName
        if (!plus && !position) {
            goodsList.update((value) => {
                return [...value, item]
            });
            selectedPlusItem.set(null);
            hiddenGoodsList.set([...goods]);
            return
        } else {
            if (currentTabName == "top") {
                item.onTop = true
            } else if (currentTabName == "bottom") {
                item.onTop = false
            }
            let exceptionList = [];
            let currentPosition = position;
            if (!position) {
                i = 0;
                currentPosition = plus.position
            }
            item.position = currentPosition
            for (let good of goods) {
                if (good.tabName == currentTabName) {
                    if (good.position == currentPosition && (good.onTop == item.onTop || good.is_big || item.is_big)) {
                        exceptionList.push({x1: good.x, x2: good.x + good.width})
                    }
                }
            }
            if (item["exception_place_" + helper.ucFirst(currentPosition) + "_" + currentTabName]) {
                for (let exception of item["exception_place_" + helper.ucFirst(currentPosition) + "_" + currentTabName]) {
                    exceptionList.push(exception)
                }
            }

            if (!position) {
                currentPositions = positions;
                if (item.onTop) {
                    currentPositions = currentPositions.filter(r => r !== "left" );
                    currentPositions = currentPositions.filter(r => r !== "right" );
                }
                let exception = helper.getException({x1: plus.x, x2: plus.x + item.width}, exceptionList);
                if (exception) {
                    mutations.addItem(item, currentPosition, exception.x2 + 1);
                    return
                }
                x = plus.x
            } else {
                let exception = helper.getException({x1: x, x2: x + item.width}, exceptionList);
                if (exception) {
                    mutations.addItem(item, currentPosition, exception.x2 + 1);
                    return
                }
            }
            if ((+currentTrack["width_" + currentPosition]) < x + item.width) {
                currentPositions = currentPositions.filter(r => r !== currentPosition);
                if (item.onTop) {
                    currentPositions = currentPositions.filter(r => r !== "left" );
                    currentPositions = currentPositions.filter(r => r !== "right" );
                }
                if (currentPositions.length) {
                    mutations.addItem(item, currentPositions[0], 0);
                    return
                } else {
                    throw {message: "return 5"};
                    return
                }
            }


            item.x = x;
            item.position = currentPosition;

            selectedItem.set(item);
            goodsList.update((value) => {
                return [...value, item]
            });
            selectedPlusItem.set(null);
            hiddenGoodsList.set([...goods]);
            refreshMinWidth()
        }

    },
    addItemsAuto(items) {
        for (let item of items) {
            if (allItems[item.id]) {
                mutations.setTabName(item.tabName)
                if (item.position) {
                    allItems[item.id].onTop = item.onTop
                    mutations.addItem(allItems[item.id], item.position, item.x)
                } else {
                    mutations.addItem(allItems[item.id])
                }
            }
        }
        mutations.setSelectedItem(null)
    },
    clearGoodsList() {
        goodsList.set([]);
        selectedPlusItem.set(null);
        selectedItem.set(null);
        hiddenGoodsList.set([]);
        refreshMinWidth();
    },
    removeItem(item) {
        goodsList.update((value) => {
            return value.filter(el => el !== item)
        });
        selectedPlusItem.set(null);
        selectedItem.set(null);
        hiddenGoodsList.set([...goods]);
        refreshMinWidth()
    },
    setSelectedPlusItem(value) {
        selectedPlusItem.set(value)
    },
    setMainTabIndex(value) {
        mainTabIndex.set(value)
    },
    setItemPosition(item, position, x) {
        item.x = x;
        item.position = position;
        goodsList.update((value) => {
            return value
        })
    },
    setIsDrag(value) {
        if (value && !isDragTimer) {
            isDragTimer = setTimeout(() => {
                isDrag.set(value);
                hiddenGoodsList.set([...goods]);
                isDragTimer = null
            }, 50)
        }


        if (!value) {
            if (isDragTimer) {
                clearTimeout(isDragTimer);
                isDragTimer = null
            }
            isDrag.set(value);
            hiddenGoodsList.set([...goods]);
            refreshMinWidth()
        }
    },
    setDraggedItem(value) {
        draggedItem.set(value)
    },
    setSelectedItem(value) {
        selectedItem.set(value)
    },
};

export const actions = {
    async getTracks() {
        const response = await fetch(config.backUrl+'/api/getTrackList', {
            mode: 'cors',
            headers: {'Access-Control-Allow-Origin': '*'}
        });
        mutations.setTrackArray(await response.json());
        mutations.loadComplete();
    },
    async getItems(trackId) {
        let response = await fetch(config.backUrl+'/api/getItems?id='+trackId, {
            mode: 'cors',
            headers: {'Access-Control-Allow-Origin': '*'}
        });
        let result = await response.json();
        mutations.setCombinedArray(result.items);
        mutations.setCategories(result.categories);
    },
    async getOrder(orderId) {
        let response = await fetch(config.backUrl+'/api/getOrder?id='+orderId, {
            mode: 'cors',
            headers: {'Access-Control-Allow-Origin': '*'}
        });
        let result = await response.json();
        return result
    }
}
function getExceptionPlaceList(value) {
    let result = []
    if (Array.isArray(value)) {
        for (let item of value) {
            let arr = item.split("-")
            if (arr.length == 2) {
                result.push({
                    x1: +arr[0],
                    x2: +arr[1],
                })
            }
        }
    }
    return result
}
function getImageUrl(name) {
    if (name) {
        return config.backUrl+"/images/"+name
    } else {
        return null
    }
}
let isDragTimer;
function refreshMinWidth() {
    if (typeof combined["bottom"] !== 'undefined') {
        let minWidth = 9999999999;
        for (let item of combined["bottom"]) {
            if (!helper.checkDisabled(item, goods)) {
                if (item.width < minWidth) {
                    minWidth = item.width
                }
            }
        }
        minimalWidthItem.set(minWidth)
    }
    if (typeof combined["top"] !== 'undefined') {
        let minWidth = 9999999999;
        for (let item of combined["top"]) {
            if (!helper.checkDisabled(item, goods)) {
            if (item.width < minWidth) {
                    minWidth = item.width
                }
            }
        }
        minimalWidthItemTop.set(minWidth)
    }
}

let i = 0;
let positions = [
    'top',
    'bottom',
    'right',
    'left',
];
let currentPositions = positions;

let plus;
selectedPlusItem.subscribe((value) => {
    plus = value
});
let combined;
combinedArray.subscribe((value) => {
    combined = value
});
let allItems;
itemsObj.subscribe((value) => {
    allItems = value
});
let goods = [];
goodsList.subscribe((value) => {
    goods = value
});
let currentTrack;
track.subscribe((value) => {
    currentTrack = value
});
let currentTabName;
tabName.subscribe((value) => {
    currentTabName = value
});
// let imagesArray;
// tabImagesArray.subscribe((value) => {
//     imagesArray = value
// });
